import {setWizardFlag} from 'stores/actions/wizardStateAction';
import {WizardFlag} from 'constants/SetupWizardEnum';
import {setEStopTriggered} from 'stores/actions/instrumentAction';
import FormattedHTMLMessage from '../../components/FormattedHTMLMessage';
import MessageBox, {getMessageBoxActionButtons} from '../../components/MessageBox';
import {LastExecEnum, RuntimeMode, SignalREvent, SignalRHub, ViewMode} from '../../constants/dataEnum';
import {hideLoading, showLoading} from '../actions/appStateAction';
import {clearTimerInterval, hideModal, setModalValid, showModal} from '../actions/modalStateAction';
import {setAbortParam} from '../actions/runtimeStateAction';
import {setCurrentPosisition} from '../actions/trayCalibrationStateAction';
import {invokeAPI, resolveIntl} from './commonBusiness';
import {abortActionBatch, abortAutoCalibration} from './instrumentBusiness';
import {checkIsTouchProbeExtendedWithModal} from './modalStateBusinessAction';
// eslint-disable-next-line import/no-cycle
import {plateCreatorRecoveryHandler} from './plateTypeEditorBusiness';
// eslint-disable-next-line import/namespace
import {checkOngoingCalibration} from './trayCalibrationBusiness';

const intl = resolveIntl();

const handleTrayCalibrationEmergencyStop = () => async (dispatch) => {
  const ongoingCalibration = await dispatch(checkOngoingCalibration());
  const {isIdle: isAutoCalibrationIdle, isExecutor} = ongoingCalibration;

  if (!isAutoCalibrationIdle && isExecutor) {
    await dispatch(abortAutoCalibration());
  }
};

// eslint-disable-next-line import/prefer-default-export
export const showEmergencyStopModal =
  (
    fastRecovery,
    // eslint-disable-next-line default-param-last
    isProtocolRunning = false,
    callback,
  ) =>
  (dispatch, getState) => {
    dispatch(hideLoading());
    const {runtimeState, appState, modalState} = getState();
    const {status, pausedOn} = runtimeState;
    const {viewMode} = appState;
    const {timerInterval} = modalState;

    if (timerInterval) dispatch(clearTimerInterval(timerInterval));

    dispatch(setModalValid());

    dispatch(
      showModal(
        intl.formatMessage({id: 'modal.emergencyStop.title'}),
        <FormattedHTMLMessage id="modal.emergencyStop.text" />,
        getMessageBoxActionButtons([
          {
            type: MessageBox.ButtonType.POSITIVE,
            text: intl.formatMessage({id: 'modal.emergencyStop.firstButton'}),
            clickHandler: async () => {
              dispatch(hideModal());

              if (viewMode === ViewMode.TRAY_CALIBRATION) await dispatch(handleTrayCalibrationEmergencyStop());

              if (
                isProtocolRunning ||
                (status !== RuntimeMode.IDLE && status !== RuntimeMode.ABORTED && status !== RuntimeMode.FINISH)
              ) {
                await dispatch(
                  setAbortParam(pausedOn === LastExecEnum.PICK_TIP || pausedOn === LastExecEnum.ALIGN_TO_ASPIRATE),
                );
                dispatch(abortActionBatch());
                dispatch(showLoading(intl.formatMessage({id: 'runtime.movingToIdleLoading'})));
                if (callback) callback();
                return;
              }

              await dispatch(fastRecovery());

              if (viewMode === ViewMode.PLATE_TYPE_EDITOR) {
                await dispatch(plateCreatorRecoveryHandler(() => {}, true));
              } else if (viewMode === ViewMode.TRAY_CALIBRATION) {
                await dispatch(invokeAPI(SignalRHub.INSTRUMENT, SignalREvent.GET_CURRENT_POSITION)).then((response) => {
                  dispatch(setCurrentPosisition(response));
                });
                await dispatch(checkIsTouchProbeExtendedWithModal());
              } else if (viewMode === ViewMode.SETUP_WIZARD) {
                dispatch(setWizardFlag(WizardFlag.ERROR));
              }
              dispatch(setEStopTriggered(false));
              if (callback) callback();
            },
          },
        ]),
        () => {
          dispatch(hideModal());
        },
        '',
        true,
      ),
    );
  };
